import apis from '../apis/apis'
import { dateToDDMMYY } from '../utils/date'

const khoaThiProcessor = {}
const controllerName = 'KhoaThi'

khoaThiProcessor.getbyId = async (id) => {
  const rs = await apis[controllerName].Get({ param: `${id}` })
  return rs.isSuccess ? rs.data : {}
}
khoaThiProcessor.getAll = async () => {
  const rs = await apis[controllerName].GetAll({})
  return rs.isSuccess
    ? rs.data.values.map((data) => {
        return {
          ...data,
          ngayBatDauStr: data.ngayBatDau ? dateToDDMMYY(new Date(data.ngayBatDau)) : undefined,
          ngayKetThucStr: data.ngayKetThuc ? dateToDDMMYY(new Date(data.ngayKetThuc)) : undefined,
        }
      })
    : []
}
khoaThiProcessor.getByNam = async (id) => {
  const rs = await apis[controllerName].GetByNam({ param: `/${id}` })
  return rs.isSuccess ? rs.data : []
}
khoaThiProcessor.upsert = async (data) => {
  let rs
  if (data.id) {
    rs = await apis[controllerName].Update({
      method: 'post',
      responseType: 'text',
      data: {
        ...data,
        // ngayBatDauStr: data.ngayBatDau,
        // ngayKetThucStr: data.ngayKetThuc,
      },
    })
  } else {
    rs = await apis[controllerName].Create({
      method: 'post',
      responseType: 'text',
      data: {
        ...data,
        // ngayBatDauStr: data.ngayBatDau,
        // ngayKetThucStr: data.ngayKetThuc,
      },
    })
  }
  return rs
}

khoaThiProcessor.delete = async (id) => {
  const rs = await apis[controllerName].Delete({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}

export default khoaThiProcessor
